import ActionMenu, { Action } from "../../../../components/ui/materialui/actionMenu";
import { PolizaSeguro, UpdatePoliza } from "../models/polizaSeguro";
import EditIcon from "@mui/icons-material/Edit";
import { GridDeleteIcon } from "@mui/x-data-grid";
import { useState } from "react";
import ConfirmationModal from "../../../../components/ui/materialui/confirmationModal";
import { deletePoliza } from "../service/servicePoliza";
import { StatusCode, TipoFuncionalidad } from "../../../../utils/enums";
import { useToast } from "../../../../hooks/useToast";
import { usePermissions } from "../../../../components/auth/ProtectedRoute";

interface IProps {
  poliza: PolizaSeguro;
  control: any;
  setPolizaEditar?: React.Dispatch<React.SetStateAction<UpdatePoliza | undefined>>;
  setModalDetalle?: React.Dispatch<React.SetStateAction<boolean>>;
  onCreateEditClick?: () => void;
  setIsEditar?: (value: boolean) => void;
}

const AccionesPoliza: React.FC<IProps> = ({
  poliza,
  control,
  setPolizaEditar,
  setModalDetalle,
  onCreateEditClick,
  setIsEditar
}) => {
  const { addToast } = useToast();
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const { hasPermission } = usePermissions();
  const puedeEditar = hasPermission(TipoFuncionalidad.Maestros_editar);

  const handleEditarClick = () => {
    if (onCreateEditClick) {
      onCreateEditClick();

      if (setPolizaEditar) {
        setPolizaEditar({
          codigo: poliza.codigo,
          nombreCompania: poliza.nombrecompania,
          diaPago: poliza.diapago,
          fechaInicio: poliza.fechainiciovigencia,
          monedaRemesa: poliza.monedapagoCodigo,
          fechaTermino: poliza.fechaterminovigencia,
          descripcion: poliza.descripcion ?? "",
        });
      }
      if (setIsEditar) {
        setIsEditar(true);
      }
    }
  };

  const handleDeleteClick = () => {
    setShowConfirmDelete(true);
  };

  const confirmDelete = async () => {

    const response = await deletePoliza(poliza.codigo);

    if (response.status === StatusCode.NoContent || response.status === StatusCode.Ok) {
      addToast({
        mostrar: true,
        titulo: 'Confirmación',
        tipo: 'Success',
        mensaje: 'Póliza eliminada con éxito.'
      });

      if (control && control.fetchData) {
        control.fetchData();
      }
    }

  };

  const actions: Action[] = [];
  if (puedeEditar) {
    actions.push({
      label: "Editar",
      icon: <EditIcon fontSize="small" />,
      onClick: handleEditarClick
    });
    actions.push({

      label: "Eliminar",
      icon: <GridDeleteIcon fontSize="small" />,
      onClick: handleDeleteClick
    },
    );
  };

  return (
    <>
      <ActionMenu actions={actions} />
      <ConfirmationModal
        show={showConfirmDelete}
        onHide={() => setShowConfirmDelete(false)}
        onConfirm={confirmDelete}
        title="Confirmar eliminación"
        message={`¿Está seguro de eliminar la póliza de seguro seleccionada?`}
        size="sm"
      />
    </>
  );
};

export default AccionesPoliza;